import { Html, useGLTF } from "@react-three/drei";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { animated } from "@react-spring/web";
import { loadingClicked } from "../../redux/loadingSlice";
import useMove from "../../utils/useMove";
import { FaArrowRight } from "react-icons/fa";
import { useFrame } from "@react-three/fiber";
import { gsap } from "gsap";

const StartPage = () => {
    const Mars = useGLTF("./assets/mars.glb");
    const dispatch = useDispatch();
    const isSaturnClicked = useSelector((state) => state.planetClickOrNot.saturnClickflag);
    const isEarthClicked = useSelector((state) => state.planetClickOrNot.earthClickflag);
    const isJupiterClicked = useSelector((state) => state.planetClickOrNot.jupiterClickflag);
    const isUranusClicked = useSelector((state) => state.planetClickOrNot.uranusClickflag);

    const isExploreButtonClicked = useSelector((state) => state.loadingClickOrNot.loadingClick);
    const handleButtonClick = () => {
        dispatch(loadingClicked());
    };
    const marsModelRef = useRef();

    const startPageHtmlRef = useRef();
    useFrame((state) => {
        if (
            isExploreButtonClicked === true &&
            isSaturnClicked === false &&
            isEarthClicked === false &&
            isJupiterClicked === false &&
            isUranusClicked === false
        ) {
            gsap.to(marsModelRef.current.position, {
                x: () => -20.37,
                y: () => 0.22,
                z: () => -500,
                duration: 8,
            });
            gsap.to(startPageHtmlRef.current.children[1].position, {
                x: () => -100,
                y: () => -100,
                z: () => -500,
                duration: 2,
            });
            gsap.to(startPageHtmlRef.current, {
                opacity: 0,
                duration: 2,
            });
            gsap.to(state.camera.position, {
                x: () => 0,
                y: () => 0,
                z: () => 5,
                duration: 2,
            });
        }
    });

    const AnimatedIcon = () => {
        const [style, trigger] = useMove({ x: 10 });
        return (
            <animated.div style={style} onMouseEnter={trigger}>
                <FaArrowRight size={20} style={{ marginLeft: "5px" }} />
            </animated.div>
        );
    };
    return (
        <group>
            <primitive object={Mars.scene} scale={0.45} position={[-16, 0, -8]} ref={marsModelRef} />;
            <Html position={isExploreButtonClicked ? [-2, 1, 0] : [0, 3, 0]} ref={startPageHtmlRef}>
                <div className="startpage-title">IPOMOEA</div>
                <div className="startpage-subtitle">WEBSITE CONCEPT</div>
                <section className="startpage-button-container">
                    <div className="startpage-button" onClick={handleButtonClick}>
                        <span className="startpage-button-text">
                            Explore
                            <AnimatedIcon />
                        </span>

                        <span className="startpage-button-line -right"></span>
                        <span className="startpage-button-line -top"></span>
                        <span className="startpage-button-line -left"></span>
                        <span className="startpage-button-line -bottom"></span>
                    </div>
                </section>
            </Html>
        </group>
    );
};

export default StartPage;
